export var filterSnackById = function (snackBarItems, id) {
    return snackBarItems.filter(function (snack) { return snack.id !== id; });
};
